import { NgModule } from '@angular/core';
import { PipesModule } from '@pipes/pipes.module';

import { SharedModule } from '../../../shared/shared.module';

const components = [];

@NgModule({
	imports: [SharedModule, PipesModule],
	exports: [...components],
	declarations: [...components],
	providers: []
})
export class ManagerComponentsModule {}
